import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import LocalTimeFromInstant from 'Components/LocalTimeFromInstant/LocalTimeFromInstant';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';

const GeneralWorkHours = ({
    registrationIdsSelected,
    isActiveFilter
}) => {
    const [idItem, setIdItem] = useState(null);
    const [workPeriodId, setWorkPeriodId] = useState(null);
    const [workPeriod, setWorkPeriod] = useState(null);
    const [lunchTime, setLunchTime] = useState(null);
    const [isActive, setIsActive] = useState('S');
    const [isSunday, setIsSunday] = useState('N');
    const [isMonday, setIsMonday] = useState('N');
    const [isTuesday, setIsTuesday] = useState('N');
    const [isWednesday, setIsWednesday] = useState('N');
    const [isThursday, setIsThursday] = useState('N');
    const [isFriday, setIsFriday] = useState('N');
    const [isSaturday, setIsSaturday] = useState('N');
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [username, setUsername] = useState(null);
    const [dtUpdate, setDtUpdate] = useState(null);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [loadingItemPanel, setLoadingItemPanel] = useState(null);
    const [recordsItemByUserId, setRecordsItemByUserId] = useState(null);
    const [attributesDetailItemPanel, setAttributesDetailItemPanel] = useState(null);
    const [workPeriods, setWorkPeriods] = useState(false);
    const [generalWorkIdSelected, setGeneralWorkIdSelected] = useState([]);

    const readOnlyAttributes = !(inserting || updating);

    const workPeriodsOptions = OptionsDataByAttributePath(workPeriods, ['description'], null, true)

    const attributeList = [
        { name: "id", value: idItem, setter: setIdItem },
        { name: "workPeriod", value: workPeriod, setter: setWorkPeriod },
        { name: "workPeriodId", value: workPeriodId, setter: setWorkPeriodId, comboboxOptions: workPeriodsOptions },
        { name: "lunchTime", value: lunchTime, setter: setLunchTime },
        {
            name: "isActive", value: isActive, setter: setIsActive, resetValue: 'S',
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        {
            name: "isSunday", value: isSunday, setter: setIsSunday, checkArgument: true, resetValue: 'N', readOnlyGrid: true,
            checks: [
                { field: 'isSunday', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        {
            name: "isMonday", value: isMonday, setter: setIsMonday, checkArgument: true, resetValue: 'N', readOnlyGrid: true,
            checks: [
                { field: 'isMonday', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        {
            name: "isTuesday", value: isTuesday, setter: setIsTuesday, checkArgument: true, resetValue: 'N', readOnlyGrid: true,
            checks: [
                { field: 'isTuesday', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        {
            name: "isWednesday", value: isWednesday, setter: setIsWednesday, checkArgument: true, resetValue: 'N', readOnlyGrid: true,
            checks: [
                { field: 'isWednesday', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        {
            name: "isThursday", value: isThursday, setter: setIsThursday, checkArgument: true, resetValue: 'N', readOnlyGrid: true,
            checks: [
                { field: 'isThursday', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        {
            name: "isFriday", value: isFriday, setter: setIsFriday, checkArgument: true, resetValue: 'N', readOnlyGrid: true,
            checks: [
                { field: 'isFriday', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        {
            name: "isSaturday", value: isSaturday, setter: setIsSaturday, checkArgument: true, resetValue: 'N', readOnlyGrid: true,
            checks: [
                { field: 'isSaturday', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        { name: "startTime", value: startTime, setter: setStartTime },
        { name: "endTime", value: endTime, setter: setEndTime },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate }
    ];

    useEffect(() => {
        setInserting(false)
        setUpdating(false)
        setGeneralWorkIdSelected([])
    }, [isActiveFilter]);

    useEffect(() => {
        const fetchData = async () => {
            const workPeriodsList = await ExecuteAxios.api('get', '/work-period/get-work-period-list/');
            setWorkPeriods(workPeriodsList);
        };

        fetchData();
    }, []);

    /*
    useEffect(() => {
        const getWorkPeriodDescription = async () => {
            if (workPeriodId) {
                const parameter = {
                    id: workPeriodId
                }
                const workPeriodDescription = await ExecuteAxios.api('get', '/work-period/get-work-period-description/', { params: parameter });
                setWorkPeriod(workPeriodDescription);
            }
        };

        getWorkPeriodDescription();
    }, [workPeriodId]);*/

    useEffect(() => {
        reloadListItem()
    }, [registrationIdsSelected, isActiveFilter])

    useEffect(() => {
        // A grid é recarregada após salvar (post/put); selecionar uma linha só busca o detalhe
        if ((!generalWorkIdSelected || generalWorkIdSelected.length != 1) && updating) {
            setUpdating(false)
        }

        if (!generalWorkIdSelected || generalWorkIdSelected.length > 1) {
            setGeneralWorkIdSelected([])
        }
    }, [generalWorkIdSelected, updating]);


    useEffect(() => {
        if (generalWorkIdSelected && generalWorkIdSelected.length === 1) {
            fetchDataDetail(generalWorkIdSelected[0]);
        } else {
            fetchDataDetail(null);
        }
    }, [generalWorkIdSelected]);

    const itemPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '83%'
    };

    async function reloadListItem() {
        const parameters = { onlyActive: isActiveFilter }
        const items = await ExecuteAxios.api('get', `/general-work-hours/get-general-work-hours-grid/`, { params: parameters });
        setRecordsItemByUserId(items);
        RemoveIdsNotFound.remove(items, setGeneralWorkIdSelected, generalWorkIdSelected)
    }

    const fetchDataDetail = async (generalWorkIdSelected) => {
        const parameters = { id: generalWorkIdSelected ? generalWorkIdSelected : 0 }
        const item = await ExecuteAxios.api('get', `/general-work-hours/get-general-work-hours-detail/`, { params: parameters })
        if (item) {
            setAttributesDetailItemPanel(item)
            ApplyAttributes.applyAttributes(item, attributeList)
        }

        if (!generalWorkIdSelected || generalWorkIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    const getItemPanelListOrDetail = () => {
        if (!updating && !inserting) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setGeneralWorkIdSelected}
                    idsSelected={generalWorkIdSelected}
                    data={recordsItemByUserId}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailItemPanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function postItem() {
        try {
            setLoadingItemPanel(true)
            const response = await ExecuteAxios.api('post', `/general-work-hours/`, {
                workPeriodId: workPeriodId,
                lunchTime: lunchTime,
                isMonday: isMonday,
                isTuesday: isTuesday,
                isWednesday: isWednesday,
                isThursday: isThursday,
                isFriday: isFriday,
                isSaturday: isSaturday,
                isSunday: isSunday,
                startTime: LocalTimeFromInstant.getLocalTimeFromInstant(startTime),
                endTime: LocalTimeFromInstant.getLocalTimeFromInstant(endTime),
                isActive: isActive
            });
            if (response) {
                await reloadListItem()
            }
            return response;
        } finally {
            setLoadingItemPanel(false)
        }
    }

    async function putItem() {
        try {
            setLoadingItemPanel(true)
            const response = await ExecuteAxios.api('put', `/general-work-hours/`, {
                id: idItem,
                workPeriodId: workPeriodId,
                lunchTime: lunchTime,
                isMonday: isMonday,
                isTuesday: isTuesday,
                isWednesday: isWednesday,
                isThursday: isThursday,
                isFriday: isFriday,
                isSaturday: isSaturday,
                isSunday: isSunday,
                startTime: LocalTimeFromInstant.getLocalTimeFromInstant(startTime),
                endTime: LocalTimeFromInstant.getLocalTimeFromInstant(endTime),
                isActive: isActive
            });

            if (response) {
                await reloadListItem()
            }

            return response;
        } finally {
            setLoadingItemPanel(false)
        }
    }

    return (
        <LoadingIndicator loaded={!loadingItemPanel}>
            <Panel
                style={itemPanelStyle}
                titlePage={'Horários de trabalho'}
                setUpdating={setUpdating}
                setInserting={setInserting}
                inserting={inserting}
                updating={updating}
                enableEdit={true}
                canEdit={generalWorkIdSelected && generalWorkIdSelected.length === 1 && registrationIdsSelected && registrationIdsSelected.length === 1}
                putFunction={putItem}
                enableNewRecord={true}
                canNewRecord={registrationIdsSelected && registrationIdsSelected.length === 1}
                postFunction={postItem}
                canViewCRUD={true}
                readOnly={false}
                recordsSelected={generalWorkIdSelected}
                viewOnlyOneRecordCRUD={true}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={attributesDetailItemPanel}
                attributeList={attributeList}
                onUpdateIdSelected={setGeneralWorkIdSelected}
            >
                {getItemPanelListOrDetail()}
            </Panel>
        </LoadingIndicator>
    );

}
export default GeneralWorkHours;